import Modal from "../../../../elements/Modal";
import ManageSubCategory from "../ManageSubCategory";

const ManageSubCategoryModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={(val) => {
        close(val);
      }}
      actualSize={"xl3"}
      size={"xl3"}
      title={"Update Sub Category"}
      subtitle="View, update and modify user details and information bellow"
      modalBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManageSubCategory
          getResponse={getResponse}
          close={close}
          data={data}
        />
      </div>
    </Modal>
  );
};

export default ManageSubCategoryModal;
